<template>
<div>
    <div class="vx-card pb-24">

        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Communication</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Télephone Fixe N° *</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.telephoneFixe" class="w-full" icon-pack="feather" icon="icon-phone" name="telephoneFixe" />
                                    <span class="text-danger text-sm" v-show="errors.has('telephoneFixe')">{{ errors.first('telephoneFixe') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Fax N°</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="infoFournissseur.fax" icon-pack="feather" icon="icon-clock" v-validate="'required'" name="fax" />
                                    <span class="text-danger text-sm" v-show="errors.has('fax')">{{ errors.first('fax') }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Email *</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.email" v-validate="'required'|'email'" class="w-full"  :dander="errors.has('email')" icon="email" name="email" />
                                    <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Mobile N° </label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.telephoneMobile" class="w-full" icon-pack="feather" icon="icon-phone" name="telephoneMobile" />
                                    <span class="text-danger text-sm" v-show="errors.has('telephoneMobile')">{{ errors.first('telephoneMobile') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Web</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.web" class="w-full" icon-pack="feather" icon="icon-web" />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
export default {
    props: {
        infoFournissseur: {
            type: Object
        }
    },
    data() {
        return {

        }
    },
    watch: {

    },
    methods: {

    },
    created() {
        this.$emit('updatePage', 1)
    },
    components: {
        vSelect
    }
}
</script>

<style>

</style>
